<script>
export default {
  name: 'DeleteAccountConfirmed',

  methods: {
    relocate() {
      this.$router.push({ name: 'homepage' }).catch(() => {})
    }
  }
}
</script>
<template>
  <v-card>
    <DialogBaseColoredTitle color="success">
      {{ $t('component.profile.accountManagement.deleteAccount.deleteAccountConfirmed.header') }}
    </DialogBaseColoredTitle>
    <v-divider></v-divider>
    <DialogBaseText class="text-center primary--text">
      <v-row>
        <v-col>
          <v-icon color="success" class="pr-2" large>mdi-check</v-icon>
          {{ $t('component.profile.accountManagement.deleteAccount.deleteAccountConfirmed.text') }}
        </v-col>
      </v-row>
    </DialogBaseText>
    <v-divider></v-divider>
    <DialogBaseActions>
      <v-row class="ma-0">
        <v-col>
          <v-btn
            id="deletionConfirmed"
            color="primary"
            class="white--text px-8"
            @click.stop="relocate"
          ><span>{{ $t('button.ok') }}</span></v-btn>
        </v-col>
      </v-row>
    </DialogBaseActions>
  </v-card>
</template>
<style lang="scss" scoped>
.v-align-center {
  vertical-align: middle;
}
</style>
